import * as angular from "angular";
import { playDialog } from "play-dialog/dist/scripts/Application";
import { playService } from "../services/app";
import { DialogService } from "./DialogService";
import { toUserTime, removeLegacyPrefix } from "./LeagueInteractionFilter";
import { SharedContestantStateService } from "./SharedContestantStateService";
import { LeagueSignUpStatusService } from "./LeagueSignUpStatusService";
import { LeagueInteractionCtrl, leagueInteraction } from "./LeagueInteractionCtrl";
import { orderTeamMember, orderByTeamName } from "./dialogs/filters";
import { ngLeague } from "ng-league/module";
import { BattlenetAccountLinkage } from "./dialogs/BattlenetAccountLinkage";
import { EaAccountLinkage } from "./dialogs/EaAccountLinkage";
import { GameAccountDialog } from "./dialogs/GameAccountDialog";
import { OculusAccountLinkage } from "./dialogs/OculusAccountLinkage";
import { PsnAccountLinkage } from "./dialogs/PsnAccountLinkage";
import { UpdateBnetOauth } from "./dialogs/UpdateBnetOauth";
import { UpdateBnetOauthContainer } from "./dialogs/UpdateBnetOauthContainer";
import { UpdateGameAccountCtrl } from "./dialogs/UpdateGameAccount";
import { XboxAccountLinkage } from "./dialogs/XboxAccountLinkage";
import { SteamAccountLinkage } from "./dialogs/SteamAccountLinkage";
import { component } from "../Component";

export let playInteraction = angular.module("play.interaction", ["ngResource", ngLeague.name, playService.name, playDialog.name]);

playInteraction.filter("toUserTime", toUserTime);
playInteraction.filter("removeLegacyPrefix", removeLegacyPrefix);
playInteraction.filter("orderTeamMember", orderTeamMember);
playInteraction.filter("orderByTeamName", orderByTeamName);
playInteraction.service("DialogService", DialogService);
playInteraction.service("SharedContestantStateService", SharedContestantStateService);
playInteraction.service("LeagueSignUpStatusService", LeagueSignUpStatusService);
playInteraction.controller("LeagueInteractionCtrl", LeagueInteractionCtrl);
playInteraction.directive("leagueInteraction", leagueInteraction);

playInteraction.component(
    "battlenetAccountLinkage",
    component({
        bindings: {
            idProvider: "<",
            gameAccountType: "<",
            gameAccountName: "<",
        },
        templateCacheUrl: "dialogs/battlenet-account-linkage.html",
        controllerAs: "ctrl",
        controller: BattlenetAccountLinkage,
    })
);

playInteraction.component(
    "eaAccountLinkage",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
        },
        templateCacheUrl: "dialogs/ea-account-linkage.html",
        controllerAs: "ctrl",
        controller: EaAccountLinkage,
    })
);

playInteraction.component(
    "gameAccountDialog",
    component({
        bindings: {
            close: "&",
            editable: "<",
            gameAccount: "<",
            valid: "<",
            leagueId: "<",
        },
        templateCacheUrl: "dialogs/game-account-dialog.html",
        controllerAs: "ctrl",
        controller: GameAccountDialog,
    })
);

playInteraction.component(
    "oculusAccountLinkage",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
        },
        templateCacheUrl: "dialogs/oculus-account-linkage.html",
        controllerAs: "ctrl",
        controller: OculusAccountLinkage,
    })
);

playInteraction.component(
    "psnAccountLinkage",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
            hasExpired: "<",
        },
        templateCacheUrl: "dialogs/psn-account-linkage.html",
        controllerAs: "ctrl",
        controller: PsnAccountLinkage,
    })
);

playInteraction.component(
    "updateBnetOauth",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
            currentGameAccount: "<",
            errorMessage: "<",
        },
        templateCacheUrl: "dialogs/update-bnet-oauth.html",
        controllerAs: "ctrl",
        controller: UpdateBnetOauth,
    })
);

playInteraction.component(
    "updateBnetOauthContainer",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
            currentGameAccount: "<",
            onSuccess: "&",
        },
        templateCacheUrl: "dialogs/update-bnet-oauth-container.html",
        controllerAs: "ctrl",
        controller: UpdateBnetOauthContainer,
    })
);

playInteraction.component(
    "updateGameAccount",
    component({
        bindings: {
            loading: "<",
            error: "<",
            editable: "<",
            gameAccountName: "<",
            gameAccountLink: "<",
            gameAccountExample: "<",
            gameAccountDescription: "<",
            gameAccountType: "<",
            hasIdProvider: "<",
            idProvider: "<",
            currentGameAccount: "<",
            isValid: "<",
            onUpdateGameAccount: "&",
            onSuccess: "&",
        },
        templateCacheUrl: "dialogs/update-game-account.html",
        controllerAs: "ctrl",
        controller: UpdateGameAccountCtrl,
    })
);

playInteraction.component(
    "xboxAccountLinkage",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
        },
        templateCacheUrl: "dialogs/xbox-account-linkage.html",
        controllerAs: "ctrl",
        controller: XboxAccountLinkage,
    })
);

playInteraction.component(
    "steamAccountLinkage",
    component({
        bindings: {
            gameAccountType: "<",
            gameAccountName: "<",
        },
        templateCacheUrl: "dialogs/steam-account-linkage.html",
        controllerAs: "ctrl",
        controller: SteamAccountLinkage,
    })
);
